import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Task, TaskWorkgroupFunctionRegistration, TaskWorkgroupRegistration } from '@/models';

@Component({
    selector: 'app-task-submission-panel',
    templateUrl: './task-submission-panel.component.html',
    styleUrls: ['./task-submission-panel.component.scss'],
    standalone: false
})
export class TaskSubmissionPanelComponent {
  @Input() registration: TaskWorkgroupRegistration;
  @Input() task: Task;
  @Input() expanded = false;

  @Output() viewRegistration = new EventEmitter<TaskWorkgroupFunctionRegistration>();

  panelOpen = false;
}
